import { Box, Button, IconButton } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { DateRangeFilter } from 'src/web/components/UI/DatePickers/DateFilter/DateRangeFilter';
import DeleteIcon from 'src/assets/icons/web/delete.svg';
import AddIcon from 'src/assets/icons/web/addHeaderButton.svg';
import { useStyles } from '../styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  addDate,
  calendarDates,
  removeDate,
  setDate,
} from 'src/redux/Calendar/sliceCalendar';
import { nanoid } from 'nanoid';

export const DatesBlock = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const dates = useSelector(calendarDates);

  const removeDateBlock = (id: string) => {
    dispatch(removeDate(id));
  };

  const addDateBlock = () => {
    dispatch(
      addDate({
        id: nanoid(8),
      })
    );
  };

  const handleChangeDate = (
    idx: number,
    _dates: { date_from: string | null; date_to: string | null }
  ): void => {
    dispatch(
      setDate({
        idx,
        value: {
          ...dates[idx],
          ..._dates,
        },
      })
    );
  };

  return (
    <Box
      mt={4}
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      style={{
        gap: '16px',
      }}
      height="fit-content">
      {dates.map(({ date_from, date_to, id }, index) => (
        <Box display="flex" alignItems="center">
          <Box minWidth={'260px'}>
            <DateRangeFilter
              key={id || '0'}
              label="Date ranges"
              placeholder="Choose date from"
              startDate={date_from?.toLocaleString()}
              endDate={date_to?.toLocaleString()}
              onChange={({ start, end }: any) => {
                handleChangeDate(index, {
                  date_from: start
                    ? moment(start)
                        .startOf('day')
                        .tz('America/Chicago', true)
                        .utc()
                        .format('YYYY-MM-DD')
                    : null,
                  date_to: end
                    ? moment(end)
                        .startOf('day')
                        .tz('America/Chicago', true)
                        .utc()
                        .format('YYYY-MM-DD')
                    : null,
                });
              }}
            />
          </Box>
          {dates.length > 1 && (
            <IconButton
              style={{ width: '40px', height: '40px' }}
              onClick={() => removeDateBlock(id)}>
              <DeleteIcon />
            </IconButton>
          )}
        </Box>
      ))}
      <IconButton className={classes.addIconButton} onClick={addDateBlock}>
        <AddIcon />
      </IconButton>
    </Box>
  );
};
